import React, { PureComponent } from 'react';

import ChannelDetails from './ChannelDetails';
import ChannelFilters from './ChannelFilters';
import Auth from "../../../libs/Auth";

class ChannelsView extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      expanded: {}
    }
  }
  toggle(id){
    const { expanded } = this.state;
    this.setState({
      expanded: {
        ...expanded,
        [id]: !expanded[id]
      }
    });
  }
  render() {
    let {
      channels,
      filtersFormState,
      page,
      nextPage,
      previousPage,
      exportCSV,
    } = this.props;

    return (
      <div className="admin-channels-view">
        <ChannelFilters {...this.props}/>
        <div className="export-csv-container">
          {Auth.isType(['admin']) && (
            <button onClick={() => exportCSV()} className="button" type="button">Export</button>
          )}
        </div>
        <table>
          <thead>
          <tr>
            <th>TradeId</th>
            <th>Card Type</th>
            <th>Code/Pin</th>
            <th>Status</th>
            <th>Type</th>
            <th>Value</th>
            <th>Created</th>
            <th>Completed</th>
            <th>Order #</th>
            <th>Email</th>
            <th></th>
          </tr>
          </thead>
          {channels.map((channel, i)=>(
            <ChannelDetails
              isEven={i%2}
              key={channel._id}
              expanded={this.state.expanded[channel._id]}
              toggle={()=>this.toggle(channel._id)}
              page={page}
              filtersFormState={filtersFormState}
              channel={channel}
            />
          ))}
          <tbody>
          <tr>
            <td colSpan="9">
              <ul className="pagination">
                <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                  {page > 1  ? (
                    <a onClick={e=>{
                      e.preventDefault();
                      previousPage();
                    }}>Previous</a>
                  ) : 'Previous'}

                </li>
                <li>{page}</li>
                <li className="pagination-next">
                  <a onClick={e=>{
                    e.preventDefault();
                    nextPage();
                  }}>Next</a>
                </li>
              </ul>
            </td>
          </tr>

          </tbody>
        </table>

      </div>
    );
  }
}

export default ChannelsView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/Channels.view.js